



























































import Vue from "vue";
import { ModuleTypes } from "@/store/ModuleTypes";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import { mapActions } from "vuex";
import { updatePlayerAvailability } from "@/helpers/api";
import rules from "@/helpers/FieldValidationRules";
import { i18n } from "@/plugins/i18n";

interface State {
  editNote: boolean;
  note: string | null;
  newNote: string;
  savingNote: boolean;
  inviteStatus: string | null;
  rules: typeof rules;
}

export default Vue.extend({
  name: "InlineNoteEditor",
  props: {
    value: { type: Boolean, required: false },
    invite: { type: Object, required: true },

    //Any change to this prop will toggle editor
    toggle: { type: Boolean, required: false }
  },
  data: (): State => ({
    editNote: false,
    note: null,
    newNote: "",
    savingNote: false,
    inviteStatus: null,
    rules: rules
  }),
  mounted() {
    this.inviteStatus = this.invite ? this.invite.status.value : null;
    this.note = this.invite ? this.invite.note : null;
    this.newNote = this.note || this.newNote;
  },
  methods: {
    toggleNoteEditor() {
      this.editNote = !this.editNote;
    },
    saveNote() {
      //@ts-ignore
      if (this.$refs.noteForm.validate()) {
        if (this.newNote != null && this.inviteStatus) {
          this.savingNote = true;
          this._updateAvailability(this.inviteStatus, this.newNote)
            .then(() => {
              this.savingNote = false;
              this.toggleNoteEditor();
              this.SHOW_SNACKBAR({
                text: i18n.tc("snackbar_message.saved_successfully")
              });
            })
            .catch(() => {
              this.SHOW_SNACKBAR({
                text: i18n.tc("snackbar_message.save_failed"),
                color: "error"
              });
            });
        }
      } else {
        this.SHOW_SNACKBAR({
          text: "Max Characters: 64 ",
          color: "error"
        });
      }
    },
    _updateAvailability(inviteStatus: string, note: string) {
      const previousStatus = this.inviteStatus;
      this.inviteStatus = inviteStatus;
      return updatePlayerAvailability(this.invite.id, inviteStatus, note)
        .then(response => {
          this.note = note;
        })
        .catch(err => {
          this.inviteStatus = previousStatus;
          alert("Error updating availability.");
        });
    },
    ...mapActions(ModuleTypes.SNACKBAR, {
      SHOW_SNACKBAR: SnackbarMutationTypes.SHOW_SNACKBAR
    })
  },
  watch: {
    toggle: function(val) {
      this.editNote = !this.editNote;
    }
  }
});
